<template>
  <chart :options="options" />
</template>

<script>
import { Chart } from 'highcharts-vue'
import Highcharts from 'highcharts'
import exportingInit from 'highcharts/modules/variable-pie'
exportingInit(Highcharts)

export default {
  components: {
    Chart
  },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    size: {
      type: Number,
      default: 240
    },
    title: {
      type: String,
      default: null
    },
    pointType: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      options: {
        colors: ['#13a2e8', '#00df9a', '#164194'],
        chart: {
          width: this.size,
          height: this.size,
          marginRight: 24,
          type: 'pie',
          style: {
            fontFamily: 'BwGlennSans-Regular',
            fontSize: '8px'
          }
        },
        title: {
          text: this.title,
          align: 'center',
          verticalAlign: 'middle',
          x: 0,
          y: 10,
          style: {
            fontFamily: 'BwGlennSans-Regular',
            fontSize: '12px',
            color: '#164194'
          }
        },
        tooltip: {
          headerFormat: '<span style="font-size:11px">{point.name}</span><br>',
          pointFormat: this.pointType == 1 ? '<span style="color:{point.color}">{point.name}</span>: {point.y} TL<br/>% {point.percentage:.2f}' : '<span style="color:{point.color}">{point.name}</span>: % {point.percentage:.2f}',
          style: {
            fontFamily: 'BwGlennSans-Regular',
            fontSize: '14px'
          }
        },
        plotOptions: {
          pie: {
            dataLabels: {
              enabled: true,
              distance: -24,
              format: '% {point.percentage:.0f}',
              style: {
                fontFamily: 'BwGlennSans-Medium',
                fontSize: '11px',
                color: 'white',
                textOutline: false
              }
            },
            showInLegend: false
          }
        },
        credits: {
          enabled: false
        },
        series: [
          {
            colorByPoint: true,
            innerSize: '60%',
            data: this.data
          }
        ]
      }
    }
  }
}
</script>